<template>
  <div class="sidebar-wrapper">
    <div class="sidebar__header">
      <h1 class="sidebar__configuration-title text-right mb-8">{{ titleEditable }}</h1>


      <!--<div class="sidebar__actions mb-8">-->
        <!--<save-button></save-button>-->
        <!--&lt;!&ndash;<button @click="save" ref="save" :class="{loading: loading, 'opacity-50': !snapshots.length, 'cursor-not-allowed': !snapshots.length }" class="button button__red sidebar__configuration-save">save</button>&ndash;&gt;-->
      <!--</div>-->
      <!--<div class="text-right mb-4">-->
        <!--<screenshot-button></screenshot-button>-->
      <!--</div>-->
      <!--<div class="text-right mb-4">-->
        <!--<snapshot-save-button></snapshot-save-button>-->
      <!--</div>-->
      

    </div>
<!-- <gui></gui> -->
    <div class="sidebar__footer">
      <div ref="snapshots" class="text-right snapshots-wrapper">
        <snapshot class="text-right py-1 hover:text-red" v-for="outfit in snapshots" :key="outfit.id" :snapshot="outfit"></snapshot>
      </div>
      <!--<camera-position-y-controller></camera-position-y-controller>-->
      <!--<zoom-controller></zoom-controller>-->
    </div>

    <div class="sidebar__actions mb-8">
      <save-button></save-button>
      <!--<button @click="save" ref="save" :class="{loading: loading, 'opacity-50': !snapshots.length, 'cursor-not-allowed': !snapshots.length }" class="button button__red sidebar__configuration-save">save</button>-->
    </div>


    <slot></slot>
  </div>
</template>

<script>

  import * as THREE from 'three';
  import { gsap } from 'gsap';
  // import { TextPlugin } from "gsap/TextPlugin";
  //
  // gsap.registerPlugin(TextPlugin);
// import Gui from './partials/GuiMorph';
  import { mapGetters, mapActions } from 'vuex';

  // import ScreenshotButton from './partials/ScreenshotButton'
  // import SnapshotSaveButton from './partials/SnapshotSaveButton'
  // import ZoomController from './ZoomController'
  // import CameraPositionYController from './CameraPositionYController'
  import Snapshot from './partials/Snapshot'
  import SaveButton from './partials/SaveButton'


  export default {
    name: "Sidebar",
    data() {
      return {
        loader: new THREE.ObjectLoader(),
        titleEditable: '',
        loading: false,
      }
    },
    components: {
      // ScreenshotButton,
      // SnapshotSaveButton,
      Snapshot,
      // ZoomController,
      // CameraPositionYController,
      SaveButton,
      // Gui
    },
    computed: {
      // ...mapGetters('mannequin',[
      //   'poser',
      // ]),
      ...mapGetters('snapshots',[
        'snapshots',
      ]),
      ...mapGetters([
        // 'scene',
        'title'
      ]),
    },
    watch: {
      snapshots: function() {
        // console.log(this.$refs.snapshots.scrollHeight);
        gsap.to(this.$refs.snapshots,{duration: 0.5, scrollTop: 0, ease: 'sine.inOut' })
        // this.$refs.snapshots.scrollTop = this.$refs.snapshots.scrollHeight;
      },
      title: function() {
        this.titleEditable = this.title;
      }
    },
    methods: {
      ...mapActions([
        'render',
      ]),
      // saveCallback(success = true) {
      //
      //   if(success)
      //     this.$Progress.finish();
      //   else
      //     this.$Progress.fail();
      //
      //   this.loading = false;
      // },
      // save() {

        // if(window.suite_editor_3d_save && this.snapshots.length > 0) {
        //
        //   try {
        //     this.$Progress.start();
        //     this.loading = true;
        //     let snapshots = JSON.stringify(this.snapshots); //JSON.parse( JSON.stringify(this.snapshots) ) Riccardo mi ha chieso di togliere il JSON.parse perchè gli da qualche problema sul backend
        //
        //     window.suite_editor_3d_save(snapshots,this.saveCallback);
        //
        //   } catch (e) {
        //     console.log(`An error occurred on save: ${e}`);
        //     this.saveCallback(false);
        //   }
        //
        // }

        // if(window.front_ajax_obj !== 'undefined' && !this.loading) {
        //
        //   this.$Progress.start();
        //   this.loading = true;
        //
        //   gsap.to(this.$refs.save, {duration: .5, text: "waiting", ease: "sine.inOut"});
        //
        //   // console.log(JSON.parse( JSON.stringify(this.snapshots) ));
        //
        //   let data_obj = {
        //     security: window.front_ajax_obj.security,
        //     action:  window.front_ajax_obj.action,
        //     post_ID: window.front_ajax_obj.post_ID,
        //     post_title: this.title,
        //     snapshots: JSON.parse( JSON.stringify(this.snapshots) ),
        //   }
        //
        //   this.$axios.post(window.front_ajax_obj.url,data_obj).then((res) => {
        //
        //     console.log(res.data);
        //     this.$Progress.finish();
        //     this.loading = false;
        //
        //     gsap.to(this.$refs.save, {duration: .5, text: "completed", ease: "sine.inOut"});
        //     gsap.to(this.$refs.save, {duration: .5, text: "save", delay: 3, ease: "sine.inOut"});
        //
        //     setTimeout(() => {
        //       this.loadingText = 'Save';
        //     },2000);
        //   }).catch((e) => {
        //     console.log(`errore: ${e}.`);
        //     this.$Progress.finish();
        //     this.loading = false;
        //     gsap.to(this.$refs.save, {duration: .5, text: "error!", ease: "sine.inOut"});
        //     gsap.to(this.$refs.save, {duration: .5, text: "save", delay: 3, ease: "sine.inOut"});
        //     alert('Ops! An error occurred. Try again.')
        //
        //
        //   });
        //
        // } else {
        //   console.log('variable front_ajax_obj not defined');
        // }



        // $('.print_btn').click(function(e){
        //   e.preventDefault();
        //   console.log('START GENERATE PDF');
        //   var data_obj = {
        //     action: 'print_moodboard_pdf',
        //     title: $(this).attr('data-title'),
        //     url: $(this).attr('data-url'),
        //     images: $(this).attr('data-images'),
        //     security: front_ajax_obj.security
        //   };
        //
        //   $.ajax({
        //     type: 'POST',
        //     url: front_ajax_obj.url,
        //     data: data_obj,
        //     success: function(result, textStatus, XMLHttpRequest) {
        //
        //       console.log(result);
        //       if ( result.success ) {
        //         gtag('event', 'print_btn', {event_category:'moodboard', event_label:result.moodboard_url});
        //         download_file( result.pdf_url, result.pdf_file_name );
        //       } else {
        //         alert(result.error);
        //         return;
        //       }
        //     },
        //     error: function(data, XMLHttpRequest, textStatus, errorThrown) {
        //       console.log(data);
        //     },
        //   });
        // })

      // }
    },
    mounted() {
      this.titleEditable = this.title;

    }
  }
</script>

<style scoped>

  .sidebar-wrapper {
    max-width: 250px;
    width: 100%;
    max-height: 100%;
    z-index: 9999;
    user-select: none;
    /*border-top: 1px solid black;*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .sidebar__header {
    padding-bottom: 30px;
  }

  .sidebar__footer {
    padding-top: 0px;
    padding-bottom: 30px;
    height: 100%;
    overflow: auto;
  }

  .sidebar__configuration-title {
    font-size: 24px;
    font-weight: 600;
    text-transform: uppercase;
    color: black;
  }

  .sidebar__configuration-id {
    font-size: 16px;
    text-transform: uppercase;
  }

  .sidebar__title {
    text-transform: uppercase;
    font-size: 14px;
    text-align: right;
  }

  /*.sidebar__configuration-save {*/
    /*text-transform: uppercase;*/
    /*min-width: 160px;*/
    /*text-align: center;*/
    /*margin-bottom: 20px;*/
  /*}*/

  /*.sidebar__configuration-save:hover, .sidebar__configuration-save.loading {*/
    /*opacity: 0.4;*/
  /*}*/

  .sidebar__actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 20px;
  }

  .snapshots-wrapper {
    display: flex;
    flex-direction: column;
    overflow: auto;
    max-height: 100%;
  }

  a {
    display: block;
    width: 100%;
  }

  @media only screen and (max-width: 1024px) {

    .sidebar__configuration-title {
      font-size: 16px;
    }

    .sidebar__configuration-save {
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }

    .sidebar-wrapper {
      height: calc(100% - 130px );
      position: absolute;
      max-width: 200px;
      top: 100px;
      right: 40px;
      /*border: 1px solid black;*/
    }

  }

</style>